import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import client from "../lib/api";

/*
  RefRedirectPage — public short-link handler.
  URL pattern: /r/:code

  Fires a visit-track ping (fire-and-forget) then hard-navigates to the
  landing page with `?ref=<code>&utm_*` appended so the signup form can
  read the code and pass it to /auth/signup.
*/
export default function RefRedirectPage() {
  const { code } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    // Fire visit ping — never block the redirect on it
    client.post(`/referrals/${code}/visit`).catch(() => {});
    // Use replace so back-button doesn't loop through /r/
    const target =
      `/?ref=${encodeURIComponent(code)}` +
      `&utm_source=referral&utm_medium=link&utm_campaign=${encodeURIComponent(code)}`;
    nav(target, { replace: true });
  }, [code, nav]);

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-neutral-500 text-sm"
      data-testid="ref-redirect-page"
    >
      Loading…
    </div>
  );
}
